import { useMemo } from "react";
import { useLocation, useParams } from "react-router";
import { getRouteObject } from "src/utils/appRoutes/appRoutes";
import {
  SECTIONS_WITH_ASSETS_FILTER,
  SECTIONS_WITH_TAGS_AND_OWNERS_FILTERS,
  SECTIONS_WITH_TIME_WINDOW_FILTER,
} from "./AssetsFilters.constants";

export interface TagResponse {
  tag_id: number;
  name: string;
  cnt: number;
}

export const useShowFilters = () => {
  const { pathname } = useLocation();
  const { app_name } = useParams();
  const currentSection = getRouteObject(pathname)?.section;

  const showEnvs = useMemo(
    () => SECTIONS_WITH_ASSETS_FILTER.includes(currentSection as never),
    [currentSection]
  );

  const showUsersFilter = useMemo(
    () =>
      SECTIONS_WITH_TAGS_AND_OWNERS_FILTERS.includes(currentSection as never) &&
      !app_name,
    [app_name, currentSection]
  );

  const showTagsFilter = useMemo(() => showUsersFilter, [showUsersFilter]);

  const showTimeFilter = useMemo(
    () => SECTIONS_WITH_TIME_WINDOW_FILTER.includes(currentSection as never),
    [currentSection]
  );

  return useMemo(
    () => ({
      showEnvs,
      showUsersFilter,
      showTagsFilter,
      showTimeFilter,
    }),
    [showEnvs, showUsersFilter, showTagsFilter, showTimeFilter]
  );
};
